<template>
<loader v-bind="{ loading }">
  <columns>
    <column>
      <columns v-for="plan in plans" :key="plan.id">
        <column>
          <plan-option :plan="plan" @selected="selectPlan" :active-plan="activePlan" :annual="annual"/>
        </column>
      </columns>
    </column>
    <column class="is-4">
      <columns>
        <column class="is-flex align-center">
          Save 20% by choosing an annual
        </column>
        <column class="is-narrow">
          <switch-input classes="is-medium is-success is-rounded" :value="annual" @input="annual = !annual"></switch-input>
        </column>
      </columns>
      <div class="box">
        <columns v-if="!hasCard">
          <column>
            <div id="card-element"></div>
          </column>
        </columns>
        <text-input  v-if="!hasCard" v-model="cardName" placeholder="Name on Card"></text-input>
        <div class="mt-2 has-text-right">
          <p class="title is-3 is-marginless">{{ total | asCurrency('USD $') }} <span class="checkout-period">{{ annual ? 'p/y' : 'p/m' }}</span></p>
          <p class="has-text-success" v-if="annual">You're saving {{ discountAmount | asCurrency('USD $') }}</p>
          <action-button 
            :working="checkingOut" 
            @click="checkout" 
            :disabled="!activePlan"
            class="mt-2 is-success">Checkout</action-button>
        </div>
        
      </div>
    </column>
  </columns>
</loader>
</template>
<script>
import { mapGetters } from 'vuex'
import PlanOption from './partials/PlanOption'
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
const elements = stripe.elements();
const cardElement = elements.create('card');

export default {

  components: { 
    PlanOption 
  },
  
  data: () => ({
    loading: true,
    stripe: null,
    annual: false,
    activePlan: null,
    cardName: '',
    checkingOut: false
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Snitch Plans')
    Promise.all([
      this.$store.dispatch('auth/loadPlans'),
      this.$store.dispatch('auth/loadCard'),
    ])
      .then(() => this.loading = false)
      .catch(error => this.loading = false)
  },

  mounted() {
    setTimeout(() => {
      cardElement.mount('#card-element');
    }, 500)
  },

  methods: {
    selectPlan(plan) {
      this.activePlan = plan
    },
    checkout() {
      this.checkingOut = true
      stripe.createToken(cardElement).then(result => {
        this.$store.dispatch('auth/subscribeToPlan', {
          plan_id: this.activePlan.id,
          annual: this.annual,
          card: result.token.id
        }).then(data => {
          this.$store.dispatch('auth/loadAccount').then(() => {
            this.$toast.success('Subscription processed successfully')
            this.$router.push({
              name: 'account'
            })
          })
           this.checkingOut = false
        }).catch(error => {
           this.checkingOut = false
        })
      }).catch(error => {
        this.checkingOut = false
      })
    }
  },

  computed: {
    ...mapGetters('auth', [
      'plans',
      'account',
      'card'
    ]),
    hasCard() {
      return this.card && this.card.id
    },
    discountAmount() {
      var annualTotal = this.activePlan.price * 12
      return (.2 * annualTotal)
    },
    total() {
      if(this.activePlan) {
        if(this.annual) {
          var annualTotal = this.activePlan.price * 12
          return annualTotal - (.2 * annualTotal)
        }
        return this.activePlan.price
      }
      return 0
    }
  }


}
</script>